<div class="pe-3 ps-3 mt-3 mb-3 review_comment_box" >
    <div class="d-flex">

        <div aria-hidden="true" class="a-profile-avatar-wrapper">
            <div class="a-profile-avatar">

                <img src="assets/customer_avatar.png" width="40"
                     height="40"
                     >
            </div>
        </div>
        <div class="d-flex justify-content-center"
             style="flex-direction: column ; padding-right: 16px; padding-left: 16px"><span
                class="a-profile-name">{{review.nickname}}</span></div>
    </div>
    <div class="pt-2 ">
        <h5 style="font-size: 16px;color: #f28714;"><b>{{review.title}}</b></h5>
    </div>

<!--        <div>-->
<!--            4.0 out of 5 stars-->
<!--        </div>-->



<!--    <span style="color: gray;">Reviewed in the United States 🇺🇸 on June 11, 2022</span>-->
    <span style="color: gray;">Reviewed at {{review.created_at | date}}</span>

    <!--    <div>-->
<!--        <span style="color: #b24e00; font-size: 12px; font-weight: 700">Verified Purchase</span>-->
<!--    </div>-->
    <div class="a-row a-spacing-small review-data"><span data-hook="review-body" class="a-size-base review-text"><div
            data-a-expander-name="review_text_read_more" data-a-expander-collapsed-height="300"
            class="a-expander-collapsed-height a-row a-expander-container a-expander-partial-collapse-container"
            style="max-height:300px"><div data-hook="review-collapsed" aria-expanded="false"
                                          class="a-expander-content reviewText review-text-content a-expander-partial-collapse-content">


    <span>{{review.detail}}</span>

</div>

    </div></span></div>

</div>
